import ConfirmationModal from "@/Component/Common/Modal/ConfirmationModal";
import { PlanChangeStatusAPI } from "@/Utils/APIRequest/Endpoints";
import { CustomToast } from "@/Utils/CustomToast";
import usePost from "@/Utils/Hooks/usePost";
import { useEffect, useState } from "react";

const ActivePlan = (props) => {
    const { elem, refetch } = props
    const [isActive, setIsActive] = useState(false);

    const [modal, setModal] = useState(null)

    useEffect(() => {
        setIsActive(elem?.status)
    }, [elem])

    // API Patch
    const { isPending, mutate } = usePost(`${PlanChangeStatusAPI}/${modal}`, null, (response) => {
        if (response.status == 200 || response.status == 201) {
            CustomToast("success", `${!isActive ? "Plan activated successfully" : "Plan Inactivated successfully"}`)
            refetch()
            setIsActive(!isActive)
            setModal(null)
        }
    }, 'Patch')

    const callbackFunction = () => {
        mutate()
    }
    return (
        <>
            <div className="flex items-center justify-center mt-6">
                <span className="mr-2 group-hover:text-white">Status</span>
                <button className={`w-16 h-8 flex items-center rounded-full p-1 ${isActive ? "bg-white border border-gray" : "bg-white border border-black"
                    }`}
                    onClick={() => setModal(elem?.id)}
                >
                    <div className={`w-6 h-6 ${isActive ? "bg-gradient-to-br from-[#CB8BFF] to-[#158CF9]" : "bg-black"} rounded-full shadow-md transform ${isActive ? "translate-x-8" : "translate-x-0"}`} ></div></button>
            </div>
            {modal && <ConfirmationModal loader={isPending} modal={modal} args={{ message: `Are you sure? You want to ${!isActive ? "Activate" : "Inactivate"} this plan` }} setModal={setModal} callbackFunction={callbackFunction} />}
        </>
    );
}

export default ActivePlan;
